export default __webpack_public_path__ + "static/media/track.096b2870.svg";